import React from "react";

const BreadCrumb = ({
  path,
  onFolderClick,
  marginTop = "mt-4",
  marginBottom = "mb-4",
}) => {
  return (
    <div
      className={`flex flex-wrap px-2 md:px-0 items-center text-sm gap-y-1 ${marginBottom} md:!mb-0`}
    >
      {path.map((folder, index) => {
        const isLast = index === path.length - 1;
        return (
          <div key={folder?.id} className={`flex items-center ${marginTop}`}>
            {isLast ? (
              <span className="font-normal text-[#232323] text-[0.9rem]">
                {folder?.name}
              </span>
            ) : (
              <button
                onClick={() => onFolderClick(folder, index)}
                className="p-0 hover:underline border-none bg-transparent text-[#666666] font-normal text-[0.9rem]"
              >
                {folder?.name}
              </button>
            )}
            {!isLast && <span className="mx-2 text-[#666666]">{">"}</span>}
          </div>
        );
      })}
    </div>
  );
};

export default BreadCrumb;
